module.exports = __webpack_public_path__ + "img/029-list.bd976f5e.svg";